import React from "react";
import { BrowserRouter } from "react-router-dom";

import { MessageProvider } from "../shared/components/message/MessageContext";
import { LoaderProvider } from "../shared/components/loader/LoaderContext";
import { childrenDefaultPropType } from "./components/shared/PropTypesHelper";

export default function Factory({ children }) {
  return (
    <BrowserRouter>
      <LoaderProvider>
        <MessageProvider>{children}</MessageProvider>
      </LoaderProvider>
    </BrowserRouter>
  );
}

Factory.propTypes = { children: childrenDefaultPropType };
